import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import {
  Wrapper,
  StyledContainer,
  Columns,
  Block,
  Content,
  StyledImage,
  Footer,
} from './styles';

// * sectionTiles {obj} richtext obj provided by primsic
// * items {array} array of data from prismic for each card. Contains a heading {string}, image src {string}, bodyCopy {string}

function ValuesSection({ sectionId, data }) {
  if (!data) return null;
  const {
    sectionTitleHtml,
    columnAlignment,
    items,
    titleHtml,
    buttonLink,
    buttonText,
    buttonType,
    ariaLabelButton,
    queryStringButton,
    lang,
  } = data;

  return (
    <Wrapper>
      <StyledContainer id={sectionId} className="auto-margin">
        {ReactHtmlParser(sectionTitleHtml)}
        <Columns className="regular-columns" columns={4}>
          {items.map(
            (
              {
                itemImage,
                imageItemSharp,
                itemHeadingHtml,
                itemSubHeadingHtml,
                itemBodyCopyHtml,
              },
              index,
            ) => (
              <Block
                className={columnAlignment}
                key={`values-${columnAlignment}-${index.toString()}`}
              >
                {imageItemSharp && (
                <StyledImage src={imageItemSharp} alt={itemImage.altTag} />
                )}
                <Content>
                  {ReactHtmlParser(itemHeadingHtml)}
                  {ReactHtmlParser(itemSubHeadingHtml)}
                  {ReactHtmlParser(itemBodyCopyHtml)}
                </Content>
              </Block>
            ),
          )}
        </Columns>
        {(titleHtml || buttonText) && (
          <Footer>
            {ReactHtmlParser(titleHtml)}
            {buttonLink && buttonText && (
              <Link
                to={`${buttonLink.url}/`}
                className={buttonType}
                ariaLabel={ariaLabelButton}
                queryString={queryStringButton}
                lang={lang}
              >
                {buttonText}
              </Link>
            )}
          </Footer>
        )}
      </StyledContainer>
    </Wrapper>
  );
}

ValuesSection.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
};

export default ValuesSection;
